import React from 'react';

// Use public/served logo so same asset works in header, PDF (fetched), and emails (linked).
// In dev Vite serves /logo.png from /public; in prod your static host should do same.
// Keep remote fallback in case the public asset path fails.
const PUBLIC_LOGO_PATH = '/logo_trans.png';
const FALLBACK_LOGO = 'https://designvault.ca/logo_trans.png'; // adjust when deployed

const Logo = ({ className }) => (
  <img
    src={PUBLIC_LOGO_PATH}
    onError={(e) => { if (e.currentTarget.src !== FALLBACK_LOGO) e.currentTarget.src = FALLBACK_LOGO; }}
    alt="Design Vault Logo"
    className={className}
    style={{ objectFit: 'contain' }}
    loading="lazy"
  />
);

export default Logo;